export default __webpack_public_path__ + "static/media/istockphoto-680194864-612x612.0a919130.jpg";